import * as React from 'react'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ChevronLeft from '@mui/icons-material/ChevronLeft'
import { useData, useHandlers } from './hooks'

export function ActivityFormHeader() {
  const { title, backButtonTitle } = useData()
  const { handleBackClick } = useHandlers()

  return (
    <Stack>
      <Stack direction="row" alignItems="center">
        <IconButton
          size="small"
          onClick={handleBackClick}
          data-test-id={`activity-back-button`}
        >
          <ChevronLeft />
        </IconButton>
        <Typography variant="body2">{backButtonTitle}</Typography>
      </Stack>
      <Typography variant="h6">{title}</Typography>
    </Stack>
  )
}
